import { suspendUser } from './states';

export const services = {
  suspendUser,
};
